module.exports = __webpack_public_path__ + "img/phone-forwarded.6bc57833.svg";